var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MyNavBar',{attrs:{"title":"医院管理入口"}}),_c('van-cell-group',_vm._l((_vm.hospitalAdmins),function(item,index){return _c('van-cell',{key:index,attrs:{"title":`医院id:${item.id} - ${item.userId}`,"is-link":""},on:{"click":function($event){return _vm.handleClick(item)}}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }